import { useTranslation } from 'react-i18next'

import Calendar from './images/calendar.webp'
import Email from './images/email.webp'
import LiveChat from './images/live-chat.webp'
import Notifications from './images/notifications.webp'
import TimeTracking from './images/time-tracking.webp'

export const useShortcutApps = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'product_tour.shortcuts'
  })

  return [
    {
      id: 'live-chat-shortcut',
      icon: '/app-icons/messenger.webp',
      name: 'Chat',
      description: t('live_chat.description'),
      imageUrl: LiveChat
    },
    {
      id: 'email-shortcut',
      icon: '/app-icons/mail.webp',
      name: 'Email',
      description: t('email.description'),
      imageUrl: Email
    },
    {
      id: 'time-tracking-shortcut',
      icon: '/app-icons/time-tracking.webp',
      name: 'Time Tracking',
      description: t('time_tracking.description'),
      imageUrl: TimeTracking
    },
    {
      id: 'calendar-shortcut',
      icon: '/app-icons/calendar.webp',
      name: 'Calendar',
      description: t('calendar.description'),
      imageUrl: Calendar
    },
    {
      id: 'notifications-shortcut',
      icon: '/app-icons/notifications.webp',
      name: 'Notifications',
      description: t('notifications.description'),
      imageUrl: Notifications
    }
  ] as const
}
